import script from "./BurnPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BurnPage.vue?vue&type=script&setup=true&lang=js"

import "./BurnPage.vue?vue&type=style&index=0&id=571820a4&lang=css"

const __exports__ = script;

export default __exports__